export function queryObjectToString<T>(qParams: T, qParamsWhichRequireBase64Encoding?: Array<string>): string {
    if(qParamsWhichRequireBase64Encoding && qParamsWhichRequireBase64Encoding.length > 0){
        let qStr = Object.keys(qParams).map((key) => key + '=' + (qParamsWhichRequireBase64Encoding.includes(key)? btoa(qParams[key as keyof T] as unknown as string) : qParams[key as keyof T])).join('&');
        qStr += '&qParamsWithBase64Encoding=' + qParamsWhichRequireBase64Encoding
        return qStr;
    }
    return Object.keys(qParams).map((key) => key + '=' + qParams[key as keyof T]).join('&');
}
